module.exports = __webpack_public_path__ + "static/media/Login_background.5ee6f41d.jpg";